import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dataTooltipComponent from "@/components/child/form/datatooltip.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import decimalComponent from "@/components/child/form/decimal.vue";
import textareaComponent from "@/components/child/form/textarea.vue";
import searchComboComponent from "@/components/child/searchCombo/search.vue";
import { Component } from "@/decorators";
import RacaAnimalModel from "@/models/paciente/racaAnimalModel";
import especieAnimalService from "@/services/paciente/especieAnimalService";
import RacaAnimalService from "@/services/paciente/racaAnimalService";

import clienteComponent from "../cliente/edit.vue";
import EditComponentBase from "../editComponentBase";

import "../crud.scss";

@Component({
    components: {
        textareaComponent,
        comboComponent,
        checkboxComponent,
        dataTooltipComponent,
        dateTimePickerComponent,
        decimalComponent,
        searchComboComponent,
        actionBarComponent,
    },
    beforeCreate: function () {
        this.$options.components["clienteComponent"] = clienteComponent;
    },
})
export default class RacaAnimalEditComponent extends EditComponentBase<RacaAnimalModel> {
    private especiesAnimalOptions: Array<Object> = [];

    private async beforeMount() {
        await this.setProps(new RacaAnimalService(), "racaAnimal", new RacaAnimalModel(), false, true);
        Promise.all([this.loadEspeciesAnimal()]);
    }

    private async loadEspeciesAnimal() {
        try {
            this.especiesAnimalOptions = await especieAnimalService.comboCached(this.usuarioLogado.franquiaId);
        } catch {}
    }

    private clear() {
        this.model = new RacaAnimalModel();
    }
}
